<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { useProvinceSelection } from '~/composables/useProvinceSelection'

const {
    showProvinceModal,
    onProvinceSaved,
    onModalHide,
    initializeProvince,
    setProvince,
} = useProvinceSelection()

// Keep in sync with public/robots.txt Disallow rules
const NO_INDEX_PATHS = [
    '/admin',
    '/auth/login',
    '/cart',
    '/information/terms-conditions',
    '/information/seg-priv-policy',
    '/information/shipment-policy',
    '/information/return-policy',
    '/information/frequent-asks',
]

const route = useRoute()

useHead({
    meta: [
        {
            name: 'robots',
            content: computed(() => {
                const path = route.path.toLowerCase()
                const shouldNoIndex = NO_INDEX_PATHS.some(
                    (p) => path === p || path.startsWith(p + '/')
                )
                return shouldNoIndex ? 'noindex, nofollow' : 'index, follow'
            }),
        },
    ],
})

onMounted(() => {
    // Initialize province from localStorage
    initializeProvince()
})
</script>

<template>
    <div>
        <NuxtLayout>
            <NuxtPage />
        </NuxtLayout>

        <!-- Global Province Selection Modal -->
        <ProvinceSelectionModal
            :model-value="showProvinceModal"
            @province-saved="onProvinceSaved"
            @hide="onModalHide"
        />

        <!-- Cookie consent banner (ePrivacy / GDPR / AEPD) -->
        <ConsentBanner />
    </div>
</template>
